// extracted by mini-css-extract-plugin
export var address = "Footer-module--address--e79cb";
export var contactDetail = "Footer-module--contact-detail--a5f3b";
export var contactDetails = "Footer-module--contact-details--dbafa";
export var container = "Footer-module--container--70893";
export var copyright = "Footer-module--copyright--a775b";
export var footer = "Footer-module--footer--2d913";
export var footerSection = "Footer-module--footer-section--3ef82";
export var scrollToTop = "Footer-module--scroll-to-top--336f3";
export var scrollToTopContainer = "Footer-module--scroll-to-top-container--bd900";
export var taglineTitle = "Footer-module--tagline-title--79063";
export var title = "Footer-module--title--6d3c8";